import type { RequestBody } from '@vrplatform/data';
import { bankersRound, day, type Maybe } from '@vrplatform/utils';
type ReservationAdjustmentUpdateBody =
  RequestBody<'put:/reservations/{reservationId}/adjustments/{id}'>;

export const buildReservationAdjustmentEditMutationBody = (args: {
  description: string;
  centTotal: number | undefined;
  postingAt: Maybe<string>;
}): ReservationAdjustmentUpdateBody => ({
  amount: bankersRound(args.centTotal ?? 0),
  description: args.description.trim() || '-',
  generalLedgerPostingAt: args.postingAt
    ? day(args.postingAt).yyyymmdd()
    : undefined,
});
